import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddEditFeeBookForm from "./AddEditFeeBookForm";
import { API_GET_FEES_BOOKS_MASTER } from "../Config/ApiUrlConstant";
import { useAuth } from "../AuthContext";

const ClassFeeBookMaster = () => {
  const [feesBooks, setFeesBooks] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchClass, setSearchClass] = useState("");
  const [searchSession, setSearchSession] = useState("");
  const { logout } = useAuth();

  const handleAddFee = () => {
    setOpen(false);
    getAllFeesBooksMaster(); // Refresh after adding
  };

  const getAllFeesBooksMaster = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(API_GET_FEES_BOOKS_MASTER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401 || response.status === 403) {
        logout();
        return;
      }

      const responseData = await response.json();
      const data = responseData.data || [];
      setFeesBooks(data);
    } catch (error) {
      console.error("Error fetching feesBooks:", error);
    }
  };

  useEffect(() => {
    getAllFeesBooksMaster();
  }, []);

  // Filtered list based on search
  const filteredFeesBooks = feesBooks.filter((fee) => {
    const classMatch = searchClass
      ? fee.class.toString().toLowerCase().includes(searchClass.toLowerCase())
      : true;
    const sessionMatch = searchSession
      ? fee.session.toString().toLowerCase().includes(searchSession.toLowerCase())
      : true;
    return classMatch && sessionMatch;
  });

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Class Fee & Book Price List
      </Typography>

      {/* Search Fields */}
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          label="Search Class"
          value={searchClass}
          onChange={(e) => setSearchClass(e.target.value)}
          size="small"
        />
        <TextField
          label="Search Session"
          value={searchSession}
          onChange={(e) => setSearchSession(e.target.value)}
          size="small"
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpen(true)}
          sx={{ marginLeft: "auto" }}
        >
          Add Class Fee & Book Price
        </Button>
      </Box>

      {/* Fee Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Class</TableCell>
              <TableCell>Fee Amount</TableCell>
              <TableCell>Book Amount</TableCell>
              <TableCell>Session</TableCell>
              <TableCell>Admission Charge</TableCell>
              <TableCell>Annual Promotion Charge</TableCell>
              <TableCell>Dairy ID Tie Belt </TableCell>
              <TableCell>Active</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredFeesBooks.length > 0 ? (
              filteredFeesBooks.map((fee) => (
                <TableRow key={fee.id}>
                  <TableCell>{fee.id}</TableCell>
                  <TableCell>{fee.class}</TableCell>
                  <TableCell>{fee.fee_amt}</TableCell>
                  <TableCell>{fee.book_amt}</TableCell>
                  <TableCell>{fee.session}</TableCell>
                  <TableCell>{fee.admin_charge}</TableCell>
                  <TableCell>{fee.annual_promotion_charge}</TableCell>
                  <TableCell>{fee.diary_id_tie_belt}</TableCell>
                  <TableCell>{fee.is_active ? "Yes" : "No"}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog for Add/Edit Form */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Add Class Fee & Book Price</DialogTitle>
        <DialogContent>
          <AddEditFeeBookForm onSubmit={handleAddFee} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ClassFeeBookMaster;
